<template>
  <div class="home-box">
    <keep-alive include="NvDiscover,NvShelf">
      <router-view></router-view>
    </keep-alive>
    <NvBottomNav />
  </div>
</template>

<script>
import NvBottomNav from "@/components/layout/NvBottomNav";

export default {
  components: {
    NvBottomNav
  }
};
</script>

<style lang="scss" scoped>
// .home-box {}
</style>
